export default __webpack_public_path__ + "static/media/photo.a13010f1.svg";